import React from 'react';
import { Modal, Button, Form, Row, Col, Spinner } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { FaWindowClose, FaFileExcel } from 'react-icons/fa';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';

// Replica uExcelGestaoIPTU.dfm — 6 campos + 1 checkbox.
// Opções literais preservadas de uExcelGestaoIPTU.pas:208-262 (RN-D6-1..11).
const OPCOES_DESPESA = [
  { value: '',               label: 'Selecione' },
  { value: '90015',          label: '90015 - IPTU lotes em estoque' },
  { value: '90034',          label: '90034 - IPTU Reembolso Clientes' },
  { value: 'Outras Despesas', label: 'Outras Despesas' },
];

const OPCOES_TIPO_DOCUMENTO = [
  { value: '',   label: 'Selecione' },
  { value: '01', label: '01 - Boleto' },
  { value: '08', label: '08 - Tributos' },
];

const OPCOES_MODALIDADE = [
  { value: '',   label: 'Selecione' },
  { value: '08', label: '08 - TED' },
  { value: '11', label: '11 - Contas de Consumo e Darf' },
  { value: '12', label: '12 - Tributos' },
  { value: '31', label: '31 - Título de Terceiros' },
];

const hoje = moment().startOf('day');

const schema = Yup.object({
  despesa: Yup.string().required('Despesa deve ser selecionada.'),
  vencimento: Yup.date()
    .required('Vencimento deve ser informado.')
    .min(hoje.toDate(), 'Vencimento não pode ser menor que a data atual.'),
  pagarEm: Yup.date()
    .required('Pagar Em deve ser informado.')
    .min(hoje.toDate(), 'Pagar Em não pode ser menor que a data atual.'),
  apuracao: Yup.date().required('Apuração deve ser informada.'),
  tipoDocumento: Yup.string().required('Tipo de Documento deve ser selecionado.'),
  modalidade: Yup.string().required('Modalidade deve ser selecionada.'),
  arquivoUnico: Yup.boolean(),
});

const ModalParametrosExcel = ({ show, onHide, onConfirmar, carregando }) => (
  <Modal show={show} onHide={onHide} size="lg" backdrop="static">
    <Modal.Header closeButton>
      <Modal.Title style={{ fontSize: 18 }}>Dados para Gerar Arquivo Excel</Modal.Title>
    </Modal.Header>
    <Formik
      initialValues={{
        despesa: '',
        vencimento: null,
        pagarEm: null,
        apuracao: null,
        tipoDocumento: '',
        modalidade: '',
        arquivoUnico: false,
      }}
      validationSchema={schema}
      onSubmit={(values) => {
        if (!window.confirm('Todas as informações estão corretas?')) return;
        onConfirmar({
          despesa: values.despesa,
          vencimento: moment(values.vencimento).format('YYYY-MM-DD'),
          pagarEm:    moment(values.pagarEm).format('YYYY-MM-DD'),
          apuracao:   moment(values.apuracao).format('YYYY-MM-DD'),
          tipoDocumento: values.tipoDocumento,
          modalidade: values.modalidade,
          arquivoUnico: values.arquivoUnico,
        });
      }}
    >
      {({ values, errors, touched, setFieldValue, handleSubmit, handleChange, handleBlur }) => (
        <Form onSubmit={handleSubmit} noValidate>
          <Modal.Body>
            <Row>
              <Col xs={12} className="mb-2">
                <Form.Label>Despesa <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  as="select"
                  name="despesa"
                  value={values.despesa}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.despesa && !!errors.despesa}
                >
                  {OPCOES_DESPESA.map((o) => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">{errors.despesa}</Form.Control.Feedback>
              </Col>

              <Col xs={12} md={6} className="mb-2">
                <Form.Label>Vencimento <span className="text-danger">*</span></Form.Label>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <DatePicker
                    value={values.vencimento}
                    onChange={(val) => {
                      setFieldValue('vencimento', val);
                      // RN-D6-13: auto-fill PagarEm quando perde foco do Vencimento.
                      if (!values.pagarEm) setFieldValue('pagarEm', val);
                    }}
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/AAAA"
                    clearable
                    inputVariant="outlined"
                    size="small"
                    fullWidth
                    InputProps={{ style: { fontSize: 13, height: 31 } }}
                  />
                </MuiPickersUtilsProvider>
                {touched.vencimento && errors.vencimento && (
                  <div className="text-danger" style={{ fontSize: 12 }}>{errors.vencimento}</div>
                )}
              </Col>

              <Col xs={12} md={6} className="mb-2">
                <Form.Label>Pagar Em <span className="text-danger">*</span></Form.Label>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <DatePicker
                    value={values.pagarEm}
                    onChange={(val) => setFieldValue('pagarEm', val)}
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/AAAA"
                    clearable
                    inputVariant="outlined"
                    size="small"
                    fullWidth
                    InputProps={{ style: { fontSize: 13, height: 31 } }}
                  />
                </MuiPickersUtilsProvider>
                {touched.pagarEm && errors.pagarEm && (
                  <div className="text-danger" style={{ fontSize: 12 }}>{errors.pagarEm}</div>
                )}
              </Col>

              <Col xs={12} md={6} className="mb-2">
                <Form.Label>Apuração <span className="text-danger">*</span></Form.Label>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <DatePicker
                    value={values.apuracao}
                    onChange={(val) => setFieldValue('apuracao', val)}
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/AAAA"
                    clearable
                    inputVariant="outlined"
                    size="small"
                    fullWidth
                    InputProps={{ style: { fontSize: 13, height: 31 } }}
                  />
                </MuiPickersUtilsProvider>
                {touched.apuracao && errors.apuracao && (
                  <div className="text-danger" style={{ fontSize: 12 }}>{errors.apuracao}</div>
                )}
              </Col>

              <Col xs={12} md={6} className="mb-2">
                <Form.Label>Tipo de Documento <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  as="select"
                  name="tipoDocumento"
                  value={values.tipoDocumento}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.tipoDocumento && !!errors.tipoDocumento}
                >
                  {OPCOES_TIPO_DOCUMENTO.map((o) => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">{errors.tipoDocumento}</Form.Control.Feedback>
              </Col>

              <Col xs={12} className="mb-2">
                <Form.Label>Modalidade <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  as="select"
                  name="modalidade"
                  value={values.modalidade}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.modalidade && !!errors.modalidade}
                >
                  {OPCOES_MODALIDADE.map((o) => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">{errors.modalidade}</Form.Control.Feedback>
              </Col>

              <Col xs={12} className="mb-2">
                <Form.Check
                  type="checkbox"
                  name="arquivoUnico"
                  label="Não gerar arquivo separado por empreendimento"
                  checked={values.arquivoUnico}
                  onChange={handleChange}
                />
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="success"
              type="submit"
              disabled={carregando}
              className="d-inline-flex align-items-center"
            >
              {carregando
                ? <Spinner animation="border" size="sm" className="mr-2" />
                : <FaFileExcel className="mr-2" />}
              Gerar Excel
            </Button>
            <Button
              variant="light"
              className="d-inline-flex align-items-center"
              onClick={onHide}
              disabled={carregando}
            >
              <FaWindowClose />
              <span className="ml-2">Fechar</span>
            </Button>
          </Modal.Footer>
        </Form>
      )}
    </Formik>
  </Modal>
);

export default ModalParametrosExcel;
